import { useMemo } from 'react';

import PropTypes from 'prop-types';

import { Select } from '@utilities';

import styles from './_index.module.scss';

const AnswerOptionsDropdown = ({ isDisabled, onChange, question, value }) => {
  const options = useMemo(() => {
    return (question?.answers || question?.options || []).map((opt) => ({
      label: opt.title || opt.text,
      value: opt.title || opt.text,
    }));
  }, [question]);

  return (
    <div className={styles['answer-options-dropdown-group']}>
      <div className={styles['answer-options-dropdown-select-wrapper']}>
        <Select
          className={styles['answer-options-dropdown-select']}
          isDisabled={isDisabled}
          isMulti
          label="ANSWER OPTIONS"
          onChange={onChange}
          options={options}
          value={value}
        />
      </div>
    </div>
  );
};

AnswerOptionsDropdown.defaultProps = {
  isDisabled: false,
  value: [],
};

AnswerOptionsDropdown.propTypes = {
  isDisabled: PropTypes.bool,
  onChange: PropTypes.func,
  question: PropTypes.shape({
    answers: PropTypes.array,
    options: PropTypes.array,
  }),
  value: PropTypes.array,
};

export default AnswerOptionsDropdown;
